import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './motoristaDiariaForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import ReactExport from 'react-export-excel-fixed-xlsx';

import {
	setModoTela, initForm, salvar, excluir, setFiltro, imprimir,
	getLista, getListaTipo, getListaMotorista, getListaVeiculo
} from './motoristaDiariaActions';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/labelAndInputMask';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

class MotoristaDiaria extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTipo();
		this.props.getListaMotorista();
		this.props.getListaVeiculo();
    }


    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
		
		return (
			<ContentCard>
				<ContentCardHeader>
					
				</ContentCardHeader>
				<ContentCardBody>
					<Row>
						<LabelAndInputMask
							label='Data' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							value={this.props.filtro.data}
							onChange={data => {
								this.props.setFiltro({
									...this.props.filtro,
									data: data.target.value
								});
							}} />

						<Grid cols='6 6 4 2' style={{ marginTop: 28, maxWidth: 180 }}>
							<Button
								text='Atualizar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.getLista();
								}} />
						</Grid>
						{(this.props.filtro.data && (!this.props.lista.length || this.props.filtro.data == DateFormat.formatarDataSqlParaTela(this.props.lista[0].data_diaria))) &&
						<Grid cols='6 6 4 2' style={{ marginTop: 28, maxWidth: 180 }}>
							<Button
								text='Processar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.salvar({
										data_diaria: this.props.filtro.data,
										processar: true
									});
								}} />
						</Grid>}

						{this.props.filtro.data &&
						<Grid cols='6 6 4 2' style={{ marginTop: 28, maxWidth: 180 }}>
							<Button
								text='Adicionar Motorista'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ data_diaria: this.props.filtro.data });
								}} />
						</Grid>}
					</Row>		
								
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th>Motorista</Th>
								<Th alignCenter>Tipo</Th>
								<Th alignCenter>Veículo</Th>
								<Th alignCenter>Cidade</Th>
								<Th alignCenter>Observação</Th>
								<Th alignCenter></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${item.nome_motorista}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome_motorista}</Td>
									<Td alignCenter>{item.nome_tipo}</Td>
									<Td alignCenter>{item.placa_veiculo}</Td>
									<Td alignCenter>{item.cidade}</Td>
									<Td alignCenter>{item.observacao}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.motoristaDiaria,
	modoTela: state.motoristaDiaria.modoTela,
	filtro: state.motoristaDiaria.filtro,
	lista: state.motoristaDiaria.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, setFiltro,
	getLista, getListaTipo, getListaMotorista, getListaVeiculo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MotoristaDiaria);
